import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Backdrop from "Components/Common/Backdrop/Backdrop";
import Spinner from "react-bootstrap/Spinner";
import { APP_SMARTVERIFY } from "Communication/Constants";

const isSmartVerify = process.env.REACT_APP_TYPE === APP_SMARTVERIFY;

const ProgressIndicator = ({ loading, message }) => {
  const isLoading = Array.isArray(loading) && loading.length > 0;

  if (!isLoading) {
    return null;
  }

  // fallback message if empty, null, or just whitespace
  const displayMessage =
    typeof message === "string" && message.trim() !== ""
      ? message
      : "Processing...";

  if (isSmartVerify) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 9999,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.75)",
        }}
      >
        <Spinner
          animation="border"
          role="status"
          style={{
            display: "block",
            width: "4.5rem",
            height: "4.5rem",
            margin: "auto",
            marginTop: "8rem",
            border: "0.4em solid #7cb9e6",
            borderRightColor: "transparent",
          }}
        />
      </div>
    );
  }

  return (
    <>
      <div className="[ progress-indicator-container ]">
        <div className="[ icon loading-icon fa-spin ]" />
        <span className="progress-message">{displayMessage}</span>
      </div>
      <Backdrop show />
    </>
  );
};

ProgressIndicator.propTypes = {
  loading: PropTypes.arrayOf(PropTypes.string),
  message: PropTypes.string,
};

ProgressIndicator.defaultProps = {
  loading: [],
  message: null,
};

const mapStateToProps = (state) => ({
  loading: state.ProgressIndicatorReducer.loading,
  message: state.ProgressIndicatorReducer.message,
});

export default connect(mapStateToProps)(ProgressIndicator);
